<template>
  <div>
    <div class="products-details-section__grid grid gap-4">
      <div class="[grid-area:header] flex flex-col gap-1">
        <SkeletonLoader
          height="100%"
          class="h-12 lg:h-7"
        />
        <SkeletonLoader
          height="100%"
          class="h-8"
        />
      </div>
      <div class="[grid-area:gallery]">
        <div class="flex gap-2">
          <div class="hidden lg:flex flex-col gap-1">
            <SkeletonLoader
              height="42px"
              width="104px"
            />
            <SkeletonLoader
              v-for="index in 5"
              :key="index"
              height="104px"
              width="104px"
            />
            <SkeletonLoader
              height="42px"
              width="104px"
            />
          </div>
          <SkeletonLoader
            height="100%"
            class="grow h-[320px] lg:h-[500px]"
          />
        </div>
      </div>
      <div class="[grid-area:pricing]">
        <SkeletonLoader
          height="500px"
        />
      </div>
      <div class="[grid-area:details]">
        <SkeletonLoader
          height="100%"
          class="h-[450px] lg:h-[600px]"
        />
      </div>
      <div class="[grid-area:review]">
        <SkeletonLoader
          height="100px"
          class="mt-4"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts">

export default defineComponent({
  name: 'ProductDetailsSectionSkeleton',
});

</script>

<style lang="scss" scoped>
@use "~/assets/scss/helpers/_breakpoints" as breakpoints;
.products-details-section {
  &__grid {
    grid-template-areas:
      "header"
      "gallery"
      "pricing"
      "details"
      "review";
    grid-template-columns: 100%;
  }

  @include breakpoints.for-desktop {
    &__grid {
      grid-template-areas:
        "gallery header header"
        "gallery details pricing"
        "review details pricing";
      grid-template-columns: 2fr 1fr 1fr;
      grid-template-rows: auto auto 1fr;
    }
  }
}
</style>
